/**
 * 이운이의어 화면, 초창기 기획. 들쑥달숙 디자인.
 * 현재 사용하지 않음
 * 이 방식은 계산이 너무 느려서 Homonym2Component로 대체됨.
 */
import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {Location} from '@angular/common';
import {animationFrameScheduler, Subject, Subscription, timer} from 'rxjs';
import {auditTime, debounceTime, delay, filter, finalize, share} from 'rxjs/operators';

import {JASO} from '../../shared/defines/gukeo.const';
import {
  DETAIL_POPUP_DELAY, HISTORY_KEY_SEARCH_HOMONYM, HOMONYM_DISP_TYPE,
  HOMONYM_SCROLL_SPEED,
  LIST_TYPE,
  REPLACE_URL_AUDIT_TIME,
  SCROLL_DEBOUNCE_TIME_HOMONYM,
  SearchParam,
  triggerDetailPopup,
  UI_RELOAD_HEIGHT_HOMONYM,
} from '../../shared/defines/client.const';
import {generateUrlWithQueryParams, GetSearchFromQuery} from '../../shared/defines/client.func';
import {NormalizeSearchParamKeyword} from '../../shared/defines/search-keyword.func';
import {IsEqualObj1, xor} from '../../shared/defines/common.func';
import {Homonym} from '../../shared/models/homonym.model';
import {ListLoader} from '../../shared/interfaces/list-loader';
import {HOMONYM_UI_BOX_TYPE, HomonymUiBox} from './homonym-ui-box';
import {LayoutMgrService} from '../../shared/services/layout-mgr/layout-mgr.service';
import {HomonymService} from '../../shared/services/homonym/homonym.service';
import {OptionService} from '../../shared/services/option/option.service';
import {VoiceService} from '../../shared/services/voice/voice.service';
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";
import {ScrollDownService} from "../../shared/services/scroll-down/scroll-down.service";
import {LastIdService} from "../../shared/services/last-id/last-id.service";
import {HeaderComponent} from "../../shared/components/header/header.component";
import {HomonymListItemComponent} from "./homonym-list-item.component";
// import _ from 'lodash';
// import {$e} from "codelyzer/angular/styles/chars";
// import * as _ from 'lodash';

const WORD_MAX_COUNT_FOR_HOMONYM = 3;

type WorkHomonym = {
  homonym: Homonym;
  uiBox?: HomonymUiBox;
  component?: HomonymListItemComponent;
};

function homonymSetPadding(homonym: Homonym, padding: {left: number, top: number}) {
  homonym.paddingLeft = padding.left;
  homonym.paddingTop = padding.top;
}


@Component({
  selector: 'app-homonym',
  templateUrl: './homonym.component.html',
  styleUrls: ['./homonym.component.scss'],
  animations: [triggerDetailPopup],
})
export class HomonymComponent implements OnInit, OnDestroy, AfterContentChecked {
  @ViewChild('container') container: ElementRef;
  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild('reload') reload: ElementRef;

  readonly HISTORY_KEY_SEARCH_HOMONYM = HISTORY_KEY_SEARCH_HOMONYM;

  initPage = false;

  HomonymBoxType = HOMONYM_UI_BOX_TYPE;

  public showDetail = false;  // 상세 팝업창이 열렸는지 여부
  public curHomonym: string = null; // 현재 선택된 이운이의어

  // 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam = null;
  private queryParams$: Subscription = null;
  private routeParams$: Subscription = null;

  // 해더에 넣는 값
  public curJasoIdx: JASO | null = null;

  // ListLoader 설정
  public ll: ListLoader<Homonym>;

  // 일단 받아온 이운이의어 정보를 보관하는 곳. 여기에 넣고 하나씩 꺼네서 listBox로 이전한다.
  private homonymQueue: Array<Homonym>;

  // 이운이의어 UI를 재구성하기 위해서 임시로 이운이의어 정보를 3개까지 보관.
  private workHomonyms: Array<WorkHomonym>;

  // 이운이의어 박스처리
  public listBox: Array<HomonymUiBox>;
  private llIndexLoad: number;

  private getNextList$: Subscription = null;
  private needReload = false;

  // 라우팅 처리
  private router$?: Subscription | null = null;

  // 라우팅 컨트롤 변수
  private scrollEvent$: Subject<void>;
  private scrollEvent$$: Subscription;
  private replaceUrl$: Subject<string>;
  private replaceUrl$$: Subscription;

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;

  private get routeHomonym(): string {
    return '/homonym';
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private zone: NgZone,
    private cdRef: ChangeDetectorRef,
    private option: OptionService,
    private voice: VoiceService,
    private homonymSvc: HomonymService,
    private globalEventSvc: GlobalEventService,
    private scrollDownSvc: ScrollDownService,
    private lastIdSvc: LastIdService,
    public lm: LayoutMgrService,
    private location: Location,
  ) {
    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams.subscribe(params => {
      console.log('queryParams =', params);
      const oldParams = {...this.queryParams};
      this.queryParams = NormalizeSearchParamKeyword({...params});
      delete this.queryParams.serial;

      // if (this.option.homonymDisp !== HOMONYM_DISP_TYPE.BASIC) {
      //   this.router.navigate(['/homonym2'], {
      //     queryParams: params,
      //     replaceUrl: true,
      //   });
      // }

      if (this.initPage) {  // 이미 로딩된 경우 == 화면이 생성된 상태

        if ('id' in this.queryParams) {
          const id = this.queryParams.id;
          // console.log('queryParams:: id=', id);

          const processParams = () => {
            const homonym = this.homonymSvc.getById(id) ?? null;
            // console.log('queryParams:: homonym=', homonym);

            if (homonym) {
              // 현재 상세 팝업창을 닫고, 새로운 단어로 다시 연다.
              this.CloseDetail();
              timer(DETAIL_POPUP_DELAY).subscribe(() => {
                this.OpenDetailPopup(homonym.name);
              });
            } else {
              // 존재하지 ㅇ낳으면, 해당 단어를 시작으로 로딩한다.
              console.warn("does not exist homonym", this.queryParams.id);
            }
          };

          if (this.homonymSvc.IsLoading()) {
            this.homonymSvc.GetNextList().pipe(
              delay(DETAIL_POPUP_DELAY),
            ).subscribe(processParams);
          } else {
            processParams();
          }
        } else {
          // id 가 없는 경우

          const params = {...oldParams};
          delete params.id;
          if (IsEqualObj1(params, this.queryParams)) {
            // 기존의 값과 id 만 빼고 동일하다면, 현재 상세 팝업창을 닫는다.
            this.CloseDetail();
          } else {
            // 기존 파라미터와 다르면, 다시 로딩한다.
            this.init();
          }
        }
      }
    });

    /******************************************************************************************
     * 라우터 주소 변경 핸들러 - 라우터 주소 읽어오는 곳.
     * 라우터 주소에 포함된 파라미터가 변경되어도 불려진다. (여기서는 type만 변경되어도 불려짐)
     *
     * queryParams가 바뀐 것(주소뒤의 파리미터가 변경된 경우)으로는 여기가 불려지지 않는다.
     */
    this.routeParams$ = route.params.subscribe(params => {
      this.init();

      this.initPage = true;
    });

    this.resetScroll();

    lm.Reset();
  }

  ngOnInit(): void {
    this.router$ = this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
    ).subscribe((event) => {

      // base url이 변경될 때만 호출
      const curBasePath = this.router.url.split('?')[0]; // 현재의 base url
      const tarBasePath = (event as NavigationStart).url.split('?')[0]; // 이동할 base url
      if (curBasePath !== tarBasePath) {
        this.onLeave();
      }
    });

    // 푸터의 스크롤 버튼 처리.
    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      if (isFirst) {
        this.onCloseItem();
      }
      const scrollDelta = HOMONYM_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });

      // if (this.container?.nativeElement) {
      //   animateScrollTo(this.container.nativeElement.scrollTop + scrollDelta, {
      //     elementToScroll: this.container.nativeElement,
      //     // speed: 400,
      //     maxDuration: LIST_SCROLL_INTERVAL - 5,
      //   }).then();
      // }
    });
  }

  ngOnDestroy(): void {
    // 화면전환시 라우팅을 위해서 히스토리 저장

    if (this.getNextList$) {
      this.getNextList$.unsubscribe();
      this.getNextList$ = null;
    }
    if (this.router$) {
      this.router$.unsubscribe();
      this.router$ = null;
    }
    if (this.queryParams$) {
      this.queryParams$.unsubscribe();
      this.queryParams$ = null;
    }
    if (this.routeParams$) {
      this.routeParams$.unsubscribe();
      this.routeParams$ = null;
    }
    if (this.scrollEvent$$) {
      this.scrollEvent$$.unsubscribe();
      this.scrollEvent$$ = null;
    }
    if (this.replaceUrl$$) {
      this.replaceUrl$$.unsubscribe();
      this.replaceUrl$$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if (this.scrollDown$) {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }

    this.CloseDetail();
  }

  ngAfterContentChecked(): void {
    // this.cdRef.detectChanges();
  }

  /****************************************************************************
   * 이운이의어 박스 처리
   ****************************************************************************/
  private BoxLoad(): void {
    let i = this.llIndexLoad;
    for (; i < this.ll.getCurCount(); ++i) {
      const homonym = this.ll.getList()[i];
      this.listBox.push(new HomonymUiBox(HOMONYM_UI_BOX_TYPE.TYPE1, [homonym]));
    }
    this.llIndexLoad = i;
  }

  private init(): void {
    // console.warn('init()');

    this.voice?.Stop();
    this.showDetail = false;
    this.curHomonym = null;
    this.CloseDetail();

    let param: SearchParam;
    this.ll = this.homonymSvc;
    [param, this.curJasoIdx] = GetSearchFromQuery(this.queryParams);
    // [param, this.curJasoIdx] = GetSearchFromQuery(this.queryParams, 'ㄱ');

    // 라우터에서 단어를 지정했을 때 start 파라미터가 없으면 추가해준다.
    // 이렇게 안 하면 로딩된 데이터에 id 에 해당하는 단어가 존재하지 않을 수 있다.
    if (this.queryParams?.id && !this.queryParams.start) {
      param.start = this.queryParams.id;
    }
    this.ReloadList(param);
  }

  private onLeave(): void {
    const top: Homonym = this.scrollTopTarget;

    if (!('keyword' in this.queryParams) // 검색어가 없는 경우만 start를 붙임.
      && top) {
      const top_name = (this.queryParams?.id && this.queryParams.id < top.name) ? this.queryParams.id : top.name;

      const queryParam: SearchParam = {
        ...(this.queryParams ? this.queryParams : {}),
        start: top_name,
      }
      const basePath = this.router.url.split('?')[0];  // query parameter를 제거
      const urlWithParams = generateUrlWithQueryParams(basePath, queryParam);
      console.warn('HomonymComponent::replaceUrl$ urlWithParams =', urlWithParams);

      // URL 변경
      this.location.replaceState(urlWithParams);

      this.lastIdSvc.setLastHomonymId(this.curHomonym ?? null, top.name);
    }
  }

  /****************************************************************************
   * 단어 목록 로딩 처리.
   ****************************************************************************/
  public ReloadList(param: SearchParam): void {
    // console.warn('ReloadList() param =', param);

    // 단어 이력보기 화면에서 자소를 선택하면 단어 검색으로 변경한다.
    // if (this.ll instanceof WordHistoryService && ('index' in param || 'keyword' in param)) {
    //   console.warn('ReloadWordList:: ll, param', this.ll, param);
    //   this.router.navigate(['/word', LIST_TYPE.SERVER], {
    //     queryParams: {...param}
    //   }).then();
    //   return;
    // }

    this.ll.ResetList(param);
    this.loadList(true);

    this.homonymQueue = new Array<Homonym>();
    this.workHomonyms = new Array<WorkHomonym>();
    this.listBox = new Array<HomonymUiBox>();
    this.llIndexLoad = 0;

    // 상세 팝업창이 열려있다면 닫는다.
    if (this.showDetail) {
      this.CloseDetail();
    }
  }


  /**
   *
   * @param cancel - 기존의 로딩을 무시하고 다시 로딩. (다른 이운이의어 검색 하는 경우, 기존 검색은 취소)
   * @private
   */
  private loadList(cancel = false): void {
    // console.warn('loadList() homonymQueue.length =', this.homonymQueue.length);

    if (cancel) {
      if (this.getNextList$) {
        console.warn('HomonymComponent::loadWordList() getNextList$.unsubscribe()');
        this.getNextList$.unsubscribe();
        this.getNextList$ = null;
      }
    }
    else if (this.getNextList$ || this.homonymQueue?.length >= WORD_MAX_COUNT_FOR_HOMONYM) {
      console.warn('HomonymComponent::loadWordList() canceled', this.getNextList$, this.homonymQueue?.length);
      return;
    }

    if (this.ll.IsComplete()) {
      console.warn('HomonymComponent::loadWordList() already load all word!');
      return;
    }

    const sharedObservable$ = this.ll.GetNextList().pipe(share());

    this.getNextList$ = sharedObservable$.pipe(
      finalize(() => {
        this.getNextList$ = null;

        if (this.needReload) {
          timer(100).subscribe(() => {
            this.needReload = false;
            this.loadList();
          });
        }
      })).subscribe(data => {
      // console.warn('is Open?', this.queryParams);

      // this.BoxLoad();

      if (this.queryParams && 'id' in this.queryParams) {
        // 바로 보기 상태라면, 서버로부터 로딩이 완료되고 나서 바로 상세 화면을 연다.
        // this.replaceState({id: this.queryParams.id, start: this.ll?.getList()[0]?.name});
        const homonym = this.ll.getById(this.queryParams.id);
        if (homonym) {
          this.OpenDetailPopup(homonym.name);
        }
      } else {
        // 인덱스 검색시 start queryparams 첫번째 단어로 정의
        // this.replaceState({start: this.ll?.getList()[0]?.name});
      }
    }, err => console.error(err));


    // 새로 항목이 로딩 된 뒤에, 주소를 변경한다.
    // sharedObservable$.pipe(
    //   delay(DETAIL_POPUP_DELAY + HOMONYM_REPOSITION_DELAY),
    // ).subscribe(ret => {
    //   if (ret.list?.length > 0) {
    //     // 이전에 진행하던 작업을 모두 취소하고 다시 넣는다.
    //     this.resetScroll();
    //
    //     const firstItem = ret.list[0];
    //     this.replaceUrl$.next(firstItem.name);
    //   } else {
    //     console.log('ret.list is empty');
    //   }
    // });
    sharedObservable$.subscribe(ret => {
      if (ret.list?.length > 0) {
        this.homonymQueue.push(...ret.list);
      }

      this.workHomonym();
    });
  }


  /**
   * 이운이의어 큐에서 하나씩 꺼내와서 처리한다.
   *
   * @private
   */
  private workHomonym(): void {
    const work = this.workHomonyms[0];
    // console.warn('workHomonym() ', work, this.homonymQueue.length, this.workHomonyms.length);

    while (this.workHomonyms.length < WORD_MAX_COUNT_FOR_HOMONYM && this.homonymQueue.length > 0) {
      const homonym = this.homonymQueue.shift();

      // 일단 처음에는 TYPE1 (단일 컬럼)으로 생성한다.
      const uiBox = new HomonymUiBox(HOMONYM_UI_BOX_TYPE.TYPE1, [homonym]);

      const workHomonym: WorkHomonym = {
        homonym,
        uiBox,
      };
      this.workHomonyms.push(workHomonym);

      this.listBox.push(uiBox);

      // console.warn('workHomonym() push', uiBox, workHomonym, this.homonymQueue.length, this.workHomonyms.length);
    }
  }

  protected onRenderListItem(listItem: HomonymListItemComponent, uiBox: HomonymUiBox) {
    // console.warn('onRenderListItem() ', uiBox);

    const homonym = uiBox.listHomonym[0];

    if (homonym === undefined) {
      console.error('onHomonymRender() homonym is null');
      return;
    }

    const workHomonym = this.workHomonyms.find(value => value.homonym === homonym);
    if (workHomonym === undefined) {
      console.error('onHomonymRender() workHomonym is null', uiBox);
      return;
    }

    workHomonym.component = listItem;

    animationFrameScheduler.schedule(() => {

      // this.workHomonyms 안에서 모두 컴포넌트를 가지고 있는지 확인 (= uiInfo가 모두 채워졌는지 확인한다.)
      while ((
        (this.workHomonyms.length >= WORD_MAX_COUNT_FOR_HOMONYM)  // 3개 이상 있거나
        || (this.ll.IsComplete() && this.workHomonyms.length > 0) // api 로딩이 완료 된 상태.
      ) && this.workHomonyms.every(value => value.component !== undefined)) {
        const work= this.workHomonyms[0];

        if (this.isType1()) {
          this.makeType1();
        }
        else if (this.isType2()) {
          this.makeType2();
        }
        else if (this.isType3()) {
          this.makeType3();
        }
        else if (this.isType4()) {
          this.makeType4();
        }
        else if (this.isType4a()) {
          this.makeType4a();
        }
        else {
          console.error('onRenderListItem() unknown type', this.workHomonyms);
        }

        this.workHomonym();
      }
    });
  }

  private isType1(): boolean {
    const work = this.workHomonyms[0];
    const component = work.component;

    if (component.isSingleColumn()) {
      return true;
    }

    const nextComponent = this.workHomonyms[1]?.component;
    if (nextComponent?.isSingleColumn()) {
      return true;
    }

    if (!nextComponent && this.ll.IsComplete()) {
      return true;
    }

    return false;
  }

  private makeType1(): void {
    const work = this.workHomonyms.shift();
    // console.warn('makeType1()', work, this.workHomonyms);
    const component = work.component;
    const homonym = work.homonym;

    homonymSetPadding(homonym, component.getPaddingType1());
    work.uiBox.visible = true;
  }

  private isType2(): boolean {
    const work = this.workHomonyms[0];
    const component = work?.component;

    if (!component) {
      console.error('isType2() component is null', component, work);
      throw new Error('isType2() component is null');
    }

    if (component.isSingleColumn()) {
      return false;
    }

    const nextComponent = this.workHomonyms[1]?.component;
    if (!nextComponent || nextComponent?.isSingleColumn()) {
      return false;
    }

    const homonym = work.homonym;
    const nextHomonym = this.workHomonyms[1]?.homonym;

    if (!xor(homonym.IsSmall(), nextHomonym.IsSmall())) {
      return true;
    }

    const _3rdWork = this.workHomonyms[2];

    // 이운이의어 모든 페이지를 로딩했는데 3열이 없는 경우.
    if (!_3rdWork && this.ll.IsComplete()) {
      return true;
    }

    // 3열이 폭이 넓은 경우.
    if (_3rdWork?.component?.isSingleColumn()) {
      return true;
    }

    // 3열이 긴 경우. type-3 이나 type-4가 안된다.
    if (!_3rdWork?.homonym?.IsSmall()) {
      return true;
    }

    return false;
  }

  /**
   * uiBox 두번째것을 제거하고 첫번째 것으로 합친다.
   * @private
   */
  private makeType2(): void {
    const work = this.workHomonyms.shift();
    // console.warn('makeType2()', work, this.workHomonyms);
    const uiBox = work?.uiBox;

    if (!uiBox) {
      throw new Error('makeType2() uiBox is null');
    }

    const nextWork = this.workHomonyms.shift();
    const nextUiBox = nextWork?.uiBox;
    const nextHomonym = nextWork?.homonym;

    if (!nextUiBox) {
      throw new Error('makeType2() nextUiBox is null');
    }

    homonymSetPadding(work.homonym, work.component.getPaddingTypeN());
    homonymSetPadding(nextHomonym, nextWork.component.getPaddingTypeN());

    uiBox.listHomonym.push(nextHomonym);
    uiBox.type = HOMONYM_UI_BOX_TYPE.TYPE2;

    // 2번째에 해당되는 항목을 제거.
    const indexListBox = this.listBox.length - this.workHomonyms.length - 1;
    this.listBox.splice(indexListBox, 1);

    work.uiBox.visible = true;
  }

  private isType3(): boolean {
    const work = this.workHomonyms[0];
    const _2ndWork = this.workHomonyms[1];
    const _3rdWork = this.workHomonyms[2];

    if (!_2ndWork || !_3rdWork) {
      return false;
    }

    const homonym = work.homonym;
    const _2ndHomonym = _2ndWork.homonym;
    const _3ndHomonym = _3rdWork.homonym;

    return (!homonym.IsSmall() && _2ndHomonym.IsSmall() && _3ndHomonym.IsSmall());
  }


  /**
   * uiBox 두번째 세번째 것을 삭제하고 첫번째에 합친다.
   * @private
   */
  private makeType3(): void {
    const work = this.workHomonyms.shift()
    // console.warn('makeType2()', work, this.workHomonyms);
    const _2ndWork = this.workHomonyms.shift();
    const _3rdWork = this.workHomonyms.shift();

    const _2ndHomonym = _2ndWork.homonym;
    const _3rdHomonym = _3rdWork.homonym;

    homonymSetPadding(work.homonym, work.component.getPaddingTypeN());
    homonymSetPadding(_2ndHomonym, _2ndWork.component.getPaddingTypeN());
    homonymSetPadding(_3rdHomonym, _3rdWork.component.getPaddingTypeN());

    const uiBox = work.uiBox;
    uiBox.type = HOMONYM_UI_BOX_TYPE.TYPE3;
    uiBox.listHomonym.push(_2ndHomonym);
    uiBox.listHomonym.push(_3rdHomonym);

    this.listBox.pop();
    this.listBox.pop();

    work.uiBox.visible = true;
  }

  private isType4(): boolean {
    const work = this.workHomonyms[0];
    const _2ndWork = this.workHomonyms[1];
    const _3rdWork = this.workHomonyms[2];

    if (!_2ndWork || !_3rdWork) {
      return false;
    }

    const homonym = work.homonym;
    // console.warn('isType4()', homonym, _2ndWork, _3rdWork);
    const _2ndHomonym = _2ndWork.homonym;
    const _3rdHomonym = _3rdWork.homonym;

    return (homonym.IsSmall() && !_2ndHomonym.IsSmall() && _3rdHomonym.IsSmall());
  }


  /**
   * uiBox 두번째 세번째 것을 삭제하고 첫번째에 합친다.
   * @private
   */
  private makeType4(): void {
    const work = this.workHomonyms.shift();
    // console.warn('makeType4()', work, this.workHomonyms);
    const _2ndWork = this.workHomonyms.shift();
    const _3rdWork = this.workHomonyms.shift();

    const _2ndHomonym = _2ndWork.homonym;
    const _3rdHomonym = _3rdWork.homonym;

    homonymSetPadding(work.homonym, work.component.getPaddingTypeN());
    homonymSetPadding(_2ndHomonym, _2ndWork.component.getPaddingTypeN());
    homonymSetPadding(_3rdHomonym, _3rdWork.component.getPaddingTypeN());

    const uiBox = work.uiBox;
    uiBox.type = HOMONYM_UI_BOX_TYPE.TYPE4;
    uiBox.listHomonym.push(_2ndHomonym);
    uiBox.listHomonym.push(_3rdHomonym);

    this.listBox.pop();
    this.listBox.pop();

    work.uiBox.visible = true;
  }


  /**
   * type-4 와는 유사한데, 3번째가 긴 경우. 2번째와 위치를 바꿔 넣는다.
   * @private
   */
  private isType4a(): boolean {
    const work = this.workHomonyms[0];
    const _2ndWork = this.workHomonyms[1];
    const _3rdWork = this.workHomonyms[2];

    if (!_2ndWork || !_3rdWork) {
      return false;
    }

    const homonym = work.homonym;
    const _2ndHomonym = _2ndWork.homonym;
    const _3rdHomonym = _3rdWork.homonym;

    return (homonym.IsSmall() && _2ndHomonym.IsSmall() && !_3rdHomonym.IsSmall());
  }

  /**
   * uiBox 두번째 세번째 것을 삭제하고 첫번째에 합친다.
   * @private
   */
  private makeType4a(): void {
    // console.warn('makeType4a()', this.workHomonyms);

    const work = this.workHomonyms.shift();
    const _2ndWork = this.workHomonyms.shift();
    const _3rdWork = this.workHomonyms.shift();

    const _2ndHomonym = _2ndWork.homonym;
    const _3rdHomonym = _3rdWork.homonym;

    homonymSetPadding(work.homonym, work.component.getPaddingTypeN());
    homonymSetPadding(_2ndHomonym, _2ndWork.component.getPaddingTypeN());
    homonymSetPadding(_3rdHomonym, _3rdWork.component.getPaddingTypeN());

    const uiBox = work.uiBox;
    uiBox.type = HOMONYM_UI_BOX_TYPE.TYPE4;
    uiBox.listHomonym.push(_3rdHomonym);
    uiBox.listHomonym.push(_2ndHomonym);

    this.listBox.pop();
    this.listBox.pop();

    work.uiBox.visible = true;
  }


  /****************************************************************************
   * 상세 팝업창 처리
   ****************************************************************************/

  onSelectItem(homonym: Homonym): void {
    // $event.preventDefault();
    // $event.stopPropagation();
    // this.globalEventSvc.Click($event);

    if (this.showDetail) {
      console.warn('HomonumComponent::onSelectItem() already show detail popup!');
      return
    }

    // const topId = this.scrollTopTarget?.name ?? null;
    // if (topId) {
    //   this.queryParams.start = topId;
    // }

    const queryParams: SearchParam = {
      ...this.queryParams,
      id: homonym.name,
    }
    this.router.navigate([this.routeHomonym], {queryParams}).then();

    this.resetScroll();
  }

  public onCloseItem(): void {
    const queryParams: SearchParam = this.queryParams
    delete queryParams.id;

    this.router.navigate([this.routeHomonym], {queryParams}).then();
  }


  public OpenDetailPopup(homonym: string): void {
    console.log('HomonumComponent::onDetailPopup() event=', event);

    this.curHomonym = homonym;
    this.showDetail = true;

    //TODO: 여기는 스크롤 무빙 적용을 안하는가?
  }


  public CloseDetail(close: boolean = false): void {
    // 클로즈 버튼을 직접 눌렀을때만 수행

    if (this.curHomonym) {
      this.curHomonym = null;
    }
    this.showDetail = false;
    this.voice.Stop();

    // 현재 책갈피 화면이라면, 닫을 때 해당 단어를 제거한다.
    // if (this.ll instanceof WordBookmarkService) {
    //   this.bmSvc.hideBookmark(this.curWordDetail.id);
    // }
  }


  /****************************************************************************
   * 일정 범위 이상 스크롤되면 남은 단어를 자동 로딩한다.
   ****************************************************************************/
  onScroll($event): void {
    if (!this.ll.IsLoading() && !this.ll.IsComplete()) {
      const tar = $event.target || $event.srcElement || $event.currentTarget;
      if (tar !== this.container.nativeElement) {
        console.error('HomonymComponent::onScroll() - wrong structure!!');
      }
      // console.log('onScroll() event =', $event,. tar);

      const elReload = this.reload.nativeElement;
      // console.log('onScroll() ', elReload.offsetTop, elReload.scrollTop, tar.offsetTop, tar.scrollTop, window.innerHeight);
      // console.warn('onScroll() ', elReload.offsetTop, window.innerHeight + tar.scrollTop);
      if (elReload.offsetTop < window.innerHeight + tar.scrollTop + UI_RELOAD_HEIGHT_HOMONYM) {
        if (this.getNextList$ === null) {
          this.loadList();
        } else {
          this.needReload = true;
        }
      }
    }

    if (!this.showDetail) {
      this.scrollEvent$.next();
    }
  }


  /**
   * 뒤로가기 할 때 현재의 화면 상태를 저장하기 위한 루틴
   * @private
   */
  private resetScroll(): void {
    console.warn('HomonymComponent::resetScroll()');

    if (this.scrollEvent$$) {
      this.scrollEvent$$.unsubscribe();
    }
    if (this.replaceUrl$$) {
      this.replaceUrl$$.unsubscribe();
    }

    this.scrollEvent$ = new Subject<void>();

    /**
     * 일정 시간 기다리는 동안 새로운 값이 들어오면 또 일정 시간을 다시 기다린다.
     * (새로운 값이 들어오면 대기 시간 연장)
     */
    this.scrollEvent$$ = this.scrollEvent$.pipe(
      debounceTime(SCROLL_DEBOUNCE_TIME_HOMONYM)  // 2000ms 이내로 이벤트가 들어오면 이전 것을 무시. 이운이의어는 2배로 늘임.
    ).subscribe(event => {
      console.warn('HomonymComponent::scrollEvent$');

      const top: Homonym = this.scrollTopTarget;
      if (top) {
        this.replaceUrl$.next(top.name);
      }
    });


    this.replaceUrl$ = new Subject<string>();

    /**
     * 일정 시간 동안 기다린 후, 최종 값을 사용함.
     * (새로운 값이 들어와도 대기 시간 연장 안함)
     */
    this.replaceUrl$$ = this.replaceUrl$.pipe(
      auditTime(REPLACE_URL_AUDIT_TIME),
      filter(() => !('keyword' in this.queryParams)),
    ).subscribe((id: string) => {
      const queryParam: SearchParam = {
        ...(this.queryParams ? this.queryParams : {}),
        start: id,
      }
      const basePath = this.router.url.split('?')[0];  // query parameter를 제거
      const urlWithParams = generateUrlWithQueryParams(basePath, queryParam);
      console.warn('HomonymComponent::replaceUrl$ urlWithParams =', urlWithParams);

      // URL 변경
      this.location.replaceState(urlWithParams);

      this.lastIdSvc.setLastHomonymId(this.curHomonym, id);
    });
  }


  /****************************************************************************
   * 단어 도움말 팝업창 처리 코드
   ***************************************************************************/

  public OpenHelp(): void {
    this.lm.showHelp = true;
  }

  public CloseHelp(showSaseung: boolean | null = null): void {
    this.lm.showHelp = false;

    if (showSaseung !== null) {
      this.option.showSaseung = showSaseung;
    }
  }



  /****************************************************************************
   * 인덱스 서칭
   ***************************************************************************/

  onSearch(param: SearchParam) {
    // this.ReloadList(param);
    this.router.navigate([this.routeHomonym], {queryParams: NormalizeSearchParamKeyword(param)}).then();

    /**
     * 검색어가 변경되면, URL 변경 작업중인 것들을 중단한다.
     */
    this.resetScroll();

    // 마지막 단어 설정을 지운다.
    this.lastIdSvc.clearLastHomonymId();
  }

  /****************************************************************************
   * 스크롤시 상단 아이템 정보 얻어오기
   ***************************************************************************/
  private lastHomonymIndex: number | null = null;
  private lastScrollTop: number = 0;

  private get scrollTopTarget(): Homonym | undefined {
    const elContainer = this.container?.nativeElement;
    if (!elContainer) {
      return;
    }
    const homonyms = this.ll.getList();
    if (!homonyms || homonyms.length === 0) {
      this.lastHomonymIndex = null;
      return;
    }

    const currentScrollTop = elContainer.scrollTop + this.header.height;
    // console.warn('scrollTopTarget:: currentScrollTop =', currentScrollTop, elContainer.scrollTop, this.header.height, this.header);

    // 스크롤 방향 확인
    let startIndex = this.lastHomonymIndex ?? 0;
    if (currentScrollTop > this.lastScrollTop && startIndex < homonyms.length - 1) {
      startIndex++;
    } else if (currentScrollTop < this.lastScrollTop && startIndex > 0) {
      startIndex--;
    }

    let low = 0;
    let high = homonyms.length - 1;
    let mid: number;
    let homonym: Homonym;

    while (low <= high) {
      mid = Math.floor((low + high) / 2);
      homonym = homonyms[mid];

      if (homonym.offsetTop >= currentScrollTop) {
        high = mid - 1;
      } else {
        low = mid + 1;
      }
    }

// 화면 상단에 가까운 항목을 반환하기 위해 high 인덱스를 사용합니다.
    if (high >= 0) {
      this.lastHomonymIndex = high;
      this.lastScrollTop = currentScrollTop;
      return homonyms[high];
    }

    this.lastScrollTop = currentScrollTop;
    this.lastHomonymIndex = null;
  }
}
